import {SkuSvTableType} from "../../../../common/types";
import ReactApexChart from "react-apexcharts";
import React, {useEffect, useState} from "react";
import {Button, Card, Col, InputNumberProps, Slider} from "antd";


type ColumnChartCatFoodBlockTwoPropsType = {
    data: SkuSvTableType[]
}

export const ColumnChartCatFoodBlockTwo = ({data}: ColumnChartCatFoodBlockTwoPropsType) => {

    // Стейт для управления зумом графика
    const [zoom, setZoom] = useState(1) // сам зум
    // Стейт для временного значения слайдера
    const [tempValue, setTempValue] = useState(zoom) // для слайдера пока тянем



    // Собираем уникальные категории (level_3)
    const categories: string[] = Array.from(new Set(data.map((item) => item.level_3)));

    // Группируем данные по неделям (week_number)
    const groupedData: { [key: string]: SkuSvTableType[] } = {};
    data.forEach((item) => {
        if (!groupedData[item.week_number]) {
            groupedData[item.week_number] = [];
        }
        groupedData[item.week_number].push(item);
    });

    // Массив цветов для серий
    const colors = ['#33b2df', '#546E7A', '#d4526e', '#13d8aa', '#A5978B', '#2b908f', '#f9a3a4', '#90ee7e',
        '#f48024', '#69d2e7'
    ]

    // Формируем series для графика: каждая неделя — отдельная серия
    const series: { name: string; data: number[], color: string }[] = [];
    Object.keys(groupedData).forEach((weekNumber, index) => {
        const weekData = groupedData[weekNumber];
        const dataForWeek: number[] = categories.map((category) => {
            const item = weekData.find((d) => d.level_3 === category);
            return item ? item.sku_city : 0; // Если данных нет, ставим 0
        });
        series.push({name: weekNumber, data: dataForWeek, color: colors[index]});
    });

    // Стейт для управления отображением серий (какие недели показывать)
    const [visibleSeries, setVisibleSeries] = useState<string[]>(series.map(s => s.name));

    // Вычисляем максимальное значение столбца для масштабирования оси
    const maxColumnValue = Math.max(
        ...categories.map((_, index) =>
            series.filter(el => visibleSeries.includes(el.name)).reduce((sum, s) => sum + (s.data[index] || 0), 0)
        )
    );

    // Шаг шкалы оси X
    const scale = maxColumnValue <= 1000 ? 50 : Math.round(maxColumnValue / 1000) * 100

    // Функция для вычисления максимального значения оси X
    const getLengthLine = () => {
        const round = Math.round(maxColumnValue / 100) * 100
        if (round < maxColumnValue) {
            return round + scale
        } else {
            return round
        }
    }

    // Максимальное значение оси X
    const maxXAxis = getLengthLine()


    // Генерация тиков для оси X
    const getTicks = () => {
        const ticks = [{numb: 0}]
        const one = maxXAxis / scale
        for (let i = 1; i <= one; i++) {
            ticks.push({numb: i * scale})
        }
        return ticks
    }




    // Сброс видимых серий при изменении данных
    useEffect(() => {
        setVisibleSeries(series.map(s => s.name));
    }, [data]); // зависимость от data — срабатывает при обновлении пропсов

    // Функция переключения видимости серий (недели)
    const toggleSeries = (seriesName: string) => {
        setVisibleSeries(prev =>
            prev.includes(seriesName)
                ? prev.filter(name => name !== seriesName)
                : [...prev, seriesName]
        );
    };

    // Отфильтрованные серии для отображения
    const filteredSeries = series.filter(s => visibleSeries.includes(s.name));

    // Обработчик изменения зума
    const onChange: InputNumberProps['onChange'] = (newValue) => {
        setZoom(newValue as number);
    };


    // Опции для ApexCharts: настройки графика, осей, цветов, тултипа, легенды
    const options = {
        chart: {
            type: 'bar' as const,
            //height: 350,
            toolbar: {
                show: false
            },
            stacked: true,
        },
        plotOptions: {
            bar: {
                borderRadius: 4,
                borderRadiusApplication: 'end' as const,
                horizontal: true,
                distributed: false,
            }
        },
        colors: series.map(el => el.color),
        xaxis: {
            categories: categories,
            labels: {
                show: false,
                style: {
                    colors: 'white',
                    fontWeight: 14,
                    fontSize: '12',

                }
            },
            max: maxXAxis,
            axisBorder: {
                show: false,
            },
            axisTicks: {
                show: false,
            },
        },
        grid: {
            show: false
        },
        yaxis: {
            labels: {
                show: true,
                style: {
                    colors: 'white',
                    fontWeight: 14,
                    fontSize: '12',

                },

                maxWidth: 300
            },
        },
        tooltip: {
            enabled: true,
            theme: 'dark',
            marker: {
                show: true,
            },
        },
        legend: {
            show: false,
            position: 'top' as 'top',
            offsetY: -10,
            horizontalAlign: 'right' as const,
            showForZeroSeries: false,
            fontSize: '14px',
            floating: false,
            labels: {
                colors: '#FFFFFF'
            },
            onItemClick: {
                toggleDataSeries: true
            },
            onItemHover: {
                highlightDataSeries: false
            },
        }
    }

    // Отрисовка карточки с графиком, легендой и слайдером зума
    return (
        <Card style={{
            background: '#293133',
            borderRadius: 20,
            marginTop: 20,
            marginBottom: 20,
            paddingLeft: 20,
            paddingRight: 20,
            textAlign: 'center'
        }}>
            {/* Заголовок */}
            <div style={{color: 'white', fontSize: 16}}>Сравнение количества уникальных товаров</div>
            {/* Кастомная легенда для переключения серий */}
            <div style={{display: 'flex', justifyContent: "space-between"}}>
                <div style={{display: 'flex', flexWrap: 'wrap', gap: '10px', marginBottom: '16px', color: 'white'}}>
                    {series.map((item, index) => (
                        <div
                            key={index}
                            onClick={() => toggleSeries(item.name)}
                            style={{
                                display: 'flex',
                                alignItems: 'center',
                                gap: '8px',
                                cursor: 'pointer',
                                padding: '4px 8px',
                                borderRadius: '4px',
                                backgroundColor: visibleSeries.includes(item.name) ? '#444' : '#222',
                                border: visibleSeries.includes(item.name) ? '1px solid #69d2e7' : '1px solid #555'
                            }}
                        >
                            {/* Цветовая метка серии */}
                            <div
                                style={{
                                    width: '12px',
                                    height: '12px',
                                    backgroundColor: options.colors?.[index % options.colors.length],
                                    borderRadius: '50%'
                                }}
                            />
                            <span style={{fontSize: '12px'}}>{item.name}</span>
                        </div>
                    ))}
                </div>
                {/* Слайдер для управления зумом графика */}
                <Col span={12}>
                    <Slider
                        min={1}
                        max={100}
                        onAfterChange={(value) => setZoom(value)}
                        onChange={(value) => setTempValue(value)}
                        value={tempValue}
                    />
                </Col>
            </div>
            {/* График ApexCharts */}
            <div style={{height: '500px', overflow: 'auto', paddingTop: 10}}>
                <ReactApexChart
                    options={options}
                    width={1380 * zoom}
                    series={filteredSeries}
                    type={'bar'}
                    height={50 * categories.length}
                    style={{color: '#FFFFFF'}}
                />
            </div>
            {/* Ось X (закомментирована, можно включить при необходимости) */}
            {/*<div style={{marginBottom: 20, color: 'white'}}>
                <div style={{height: 2, backgroundColor: 'white', width: 'calc(100% - 330px)', marginLeft: 311}}></div>
                <div style={{
                    marginLeft: 312,
                    display: "flex",
                    justifyContent: 'space-between',
                    width: 'calc(100% - 330px)'
                }}>
                    {getTicks().map((el) => {
                        return <div>
                            <div style={{height: 3, width: 1, backgroundColor: 'white',}}></div>
                            <div style={{position: 'absolute'}}>{el.numb}</div>
                        </div>
                    })}
                </div>
            </div>*/}

        </Card>
    );
};
